var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { BRAND_LOGO_DIMENSIONS } from "@irati/brand/constants/brand";
import padding from "@irati/ui/src/global/padding";
import Icon from "@irati/ui/src/Icon";
import ProfilePictureBase from "@irati/ui/src/ProfilePicture";
export var BrandedImg = styled.img(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: auto 10px;\n  width: ", "px;\n  height: ", "px;\n  display: none;\n  flex: none;\n  ", "\n  ", "\n"], ["\n  margin: auto 10px;\n  width: ", "px;\n  height: ", "px;\n  display: none;\n  flex: none;\n  ",
    "\n  ",
    "\n"])), BRAND_LOGO_DIMENSIONS.width, BRAND_LOGO_DIMENSIONS.height, function (_a) {
    var small = _a.small;
    return small && "\n    width: 122px;\n    height: 30px;\n  ";
}, function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.minWidthMedia.tablet(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: block;\n  "], ["\n    display: block;\n  "])));
});
export var PopupBox = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  z-index: 999;\n  border-radius: 3px;\n  background-color: ", ";\n  box-shadow: ", ";\n  padding: ", " ", ";\n  min-width: 160px;\n"], ["\n  position: absolute;\n  z-index: 999;\n  border-radius: 3px;\n  background-color: ", ";\n  box-shadow: ", ";\n  padding: ", " ", ";\n  min-width: 160px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.shadows.low;
}, padding.small, padding.tiny);
export var MenuIcon = styled(Icon).attrs({
    icon: "downArrow",
    size: 12
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-left: 5px;\n"], ["\n  margin-left: 5px;\n"])));
export var ProfilePicture = styled(ProfilePictureBase)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin-right: 5px;\n"], ["\n  margin-right: 5px;\n"])));
export { default as HeaderLink } from "./HeaderLink";
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
